export default __webpack_public_path__ + "static/media/close.a1852e7b.svg";